'use client';

import dynamic from 'next/dynamic';

const HeroImageWallBackground = dynamic(
  () =>
    import('./hero-image-wall-background.client').then(
      (m) => m.HeroImageWallBackground
    ),
  { ssr: false }
);

export function HeroImageWallBackgroundLazy() {
  return <HeroImageWallBackground />;
}


